import filterCategoriesSearch from "pages/search/filtering/filterCategories.json";
import { i18n } from "../../../app/i18n/i18n";
import { getParam, push, addParam, removeParam, setParam } from "../../search/api/filterUrlMaker";

// TODO refactor

let filters = {};
let isAllChecked = {};
const categoryMap = {};
const filterCategories = [
  ...filterCategoriesSearch,
  {
    category_en: "Country",
    category_ja: "Country-JA",
    es_category_en: "countries.en",
    es_category_ja: "countries.ja",
  },
];
filterCategories.forEach((element) => {
  categoryMap[element["category_en"]] = element;
});

export const _c = (category) =>
  categoryMap[category] ? categoryMap[category]["category_" + i18n.getLanguage()] || category : category; // to get category according to app language

export const getTagsFromURL = (category, optionsList = []) => {
  // for autocomplete prepopulation
  let tags = [];
  let selected = getParam(category) || [];
  selected = Array.isArray(selected) ? selected : [selected];
  tags = !optionsList.length
    ? selected.map((el) => ({ id: el, name: el }))
    : optionsList.filter((el) => selected.includes(el.id));
  return tags.length ? tags : [{ id: "", name: "All" }];
};

// to refactor
export const getTagsFromURLServer = (category) => {
  // for server autocomplete prepopulation
  let tags = [];
  let selected = getParam(categoryToCategoryName[category]) || [];
  let selectedJA = getParam(categoryToCategoryName[category] + "-JA") || []; // Both ja and en filters may be present in case of server autocomplete
  selected = Array.isArray(selected) ? selected : [selected];
  selectedJA = Array.isArray(selectedJA) ? selectedJA : [selectedJA];
  selected = selected.map((el) => ({ id: el, name: el, lang: "en" }));
  selectedJA = selectedJA.map((el) => ({ id: el, name: el, lang: "ja" }));
  tags = [...selected, ...selectedJA];
  return tags.length ? tags : [{ id: "", name: "All" }];
};

// to refactor
export const createFiltersFromForm = (e) => {
  // logic for creating filters after form submit
  filters = {};
  isAllChecked = {};
  let arr = Array.from(e.target.elements);
  arr.filter((el) => el.attributes.datainputtype).map(setFilters);

  Object.entries(filters).forEach(([key, values]) => {
    push(removeParam(key));
    if (Array.isArray(values)) {
      if (values.length !== isAllChecked[key])
        values.forEach((value) => {
          push(addParam(key, value));
        });
    } else {
      if (values) push(setParam(key, values));
      else push(removeParam(key));
    }
  });
};

// to refactor
const setFilters = (el) => {
  const datafield = _c(el.attributes.datafield.value);
  if (el.attributes.datainputtype.value === "check") {
    filters[datafield] = filters[datafield] || [];
    isAllChecked[datafield] = ++isAllChecked[datafield] || 1;
    if (el.checked && !el.attributes.dataremove) {
      filters[datafield].push(el.attributes.datavalue.value);
    }
  }
  if (el.attributes.datainputtype.value === "radio" && el.checked) {
    filters[datafield] = el.attributes.datavalue.value;
  }
  if (el.attributes.datainputtype.value === "text") {
    filters[datafield] = el.value;
  }
  if (el.attributes.datainputtype.value === "autocomplete") {
    isAllChecked[datafield] = el.attributes.total.value;
    if (el.attributes.datalang.value) {
      const field = categoryToCategoryName[datafield]; // Needed for Server Autocompletes
      const fieldJA = field + "-JA";
      const langs = el.attributes.datalang.value.split("|").filter((el) => el) || [];
      const data = el.attributes.datavalue.value.split("|").filter((el) => el) || [];
      const bucket = {};
      bucket[field] = [];
      bucket[fieldJA] = [];
      langs.forEach((lang, k) => {
        bucket[field + (lang === "ja" ? "-JA" : "")].push(data[k]);
      });
      filters = { ...filters, ...bucket };
    } else {
      filters[datafield] = el.attributes.datavalue.value.split("|").filter((el) => el) || [];
    }
  }
  return el;
};

const categoryToCategoryName = {
  Company: "CompanyWithTicker",
  "Company-JA": "CompanyWithTicker",
  Analyst: "Analyst",
  "Analyst-JA": "Analyst",
  Country: "Country",
  "Country-JA": "Country",
};
